__turbopack_context__.v({
  "actions": "AudioLanding-module__T-K4tG__actions",
  "capability": "AudioLanding-module__T-K4tG__capability",
  "container": "AudioLanding-module__T-K4tG__container",
  "create": "AudioLanding-module__T-K4tG__create",
  "deck": "AudioLanding-module__T-K4tG__deck",
  "deckBody": "AudioLanding-module__T-K4tG__deckBody",
  "deckTop": "AudioLanding-module__T-K4tG__deckTop",
  "direction": "AudioLanding-module__T-K4tG__direction",
  "directionWrap": "AudioLanding-module__T-K4tG__directionWrap",
  "eyebrow": "AudioLanding-module__T-K4tG__eyebrow",
  "faq": "AudioLanding-module__T-K4tG__faq",
  "final": "AudioLanding-module__T-K4tG__final",
  "formatList": "AudioLanding-module__T-K4tG__formatList",
  "hero": "AudioLanding-module__T-K4tG__hero",
  "heroCopy": "AudioLanding-module__T-K4tG__heroCopy",
  "heroNote": "AudioLanding-module__T-K4tG__heroNote",
  "intro": "AudioLanding-module__T-K4tG__intro",
  "mode": "AudioLanding-module__T-K4tG__mode",
  "modes": "AudioLanding-module__T-K4tG__modes",
  "page": "AudioLanding-module__T-K4tG__page",
  "play": "AudioLanding-module__T-K4tG__play",
  "playError": "AudioLanding-module__T-K4tG__playError",
  "possibilities": "AudioLanding-module__T-K4tG__possibilities",
  "possibilitiesInner": "AudioLanding-module__T-K4tG__possibilitiesInner",
  "primary": "AudioLanding-module__T-K4tG__primary",
  "promptBottom": "AudioLanding-module__T-K4tG__promptBottom",
  "promptCount": "AudioLanding-module__T-K4tG__promptCount",
  "promptForm": "AudioLanding-module__T-K4tG__promptForm",
  "promptTop": "AudioLanding-module__T-K4tG__promptTop",
  "promptWorkspace": "AudioLanding-module__T-K4tG__promptWorkspace",
  "questions": "AudioLanding-module__T-K4tG__questions",
  "referenceNote": "AudioLanding-module__T-K4tG__referenceNote",
  "related": "AudioLanding-module__T-K4tG__related",
  "sampleCategory": "AudioLanding-module__T-K4tG__sampleCategory",
  "sampleChoices": "AudioLanding-module__T-K4tG__sampleChoices",
  "sampleNote": "AudioLanding-module__T-K4tG__sampleNote",
  "samplePrompt": "AudioLanding-module__T-K4tG__samplePrompt",
  "sampleUse": "AudioLanding-module__T-K4tG__sampleUse",
  "secondary": "AudioLanding-module__T-K4tG__secondary",
  "sectionHeader": "AudioLanding-module__T-K4tG__sectionHeader",
  "transport": "AudioLanding-module__T-K4tG__transport",
  "wave": "AudioLanding-module__T-K4tG__wave",
});
